import { descifrar } from './utils/tokenUtils';

const construirClave = () => {
    const offsetToken = process.env.REACT_APP_AUTH_TOKEN;
    if (!offsetToken) return '';
    return descifrar(offsetToken);
};

export const env = {
    envName: "DEV",
    production: false,
    test: false,
    applicationName: "chatAi",
    defaultLanguage: "en",
    get llaveMaestra() {
        return construirClave();
    },
    baseURL: process.env.REACT_APP_BASE_URL,
    aichatBaseURL: process.env.REACT_APP_AICHAT_BASE_URL,
    translateBaseURL: process.env.REACT_APP_TRANSLATE_BASE_URL,
    procurementBaseURL: process.env.REACT_APP_PROCUREMENT_BASE_URL,
    GMTBaseURL: process.env.REACT_APP_GMT_BASE_URL,
    deepInsightsURL: process.env.REACT_APP_DEEP_INSIGHTS_BASE_URL,
    productLabelBaseURL: process.env.REACT_APP_PRODUCT_LABEL_URL,
    talentPulseBaseURL: process.env.REACT_APP_TALENT_PULSE_BASE_URL,
    aichatExcelBaseURL: process.env.REACT_APP_AICHAT_EXCEL_BASE_URL,
}